import styled from 'styled-components'

export const GlobalSearchViewLayoutStyled = styled.div`
  display: grid;
  grid-template-areas:
    'header'
    'content';
  grid-template-columns: minmax(0, 1fr);
`

export const GlobalSearchViewHeaderAreaStyled = styled.div`
  grid-area: header;
`

export const GlobalSearchViewContentAreaStyled = styled.div`
  grid-area: content;
`
